export const top_sellers_in_region = {
	status: 200,
	data: {
		image_urls: [
			'https://fileserver-g-p.sourcerer.tech/files/9b55bef1-7c77-4e64-bada-7defffafced5?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
			'https://fileserver-g-p.sourcerer.tech/files/ebda502b-ab92-450f-a770-83a647d2c793?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
		],
		variant_ids: [
			'c2abb343-eee9-4e1b-94cb-dd5793e3bc68',
			'80dfc073-c827-4b03-89c1-5cb58daa5052',
			'5adcfbc9-e196-4a21-bee8-e9c3096c63b4',
			'0e46cc87-83bb-40b3-add7-bde247cd7557',
			'b98b0c17-8567-492f-91e1-dbf1f1829acb',
			'85d5b3e5-4559-470a-b5b1-9e7246f5ab9b',
			'aeb76b2e-ea47-475e-a1fa-e23bf4a5b176',
		],
		type: 'top_sellers_in_region',
	},
};
export const top_picks_from_favourite_categories = {
	status: 200,
	data: {
		image_urls: [
			'https://fileserver-g-p.sourcerer.tech/files/9b55bef1-7c77-4e64-bada-7defffafced5?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
			'https://fileserver-g-p.sourcerer.tech/files/ebda502b-ab92-450f-a770-83a647d2c793?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
		],
		variant_ids: [
			'c2abb343-eee9-4e1b-94cb-dd5793e3bc68',
			'80dfc073-c827-4b03-89c1-5cb58daa5052',
			'5adcfbc9-e196-4a21-bee8-e9c3096c63b4',
			'0e46cc87-83bb-40b3-add7-bde247cd7557',
			'b98b0c17-8567-492f-91e1-dbf1f1829acb',
		],
		type: 'top_picks_from_favourite_categories',
	},
};
export const similar_to_previous_order = {
	status: 200,
	data: {
		image_urls: [
			'https://fileserver-g-p.sourcerer.tech/files/9b55bef1-7c77-4e64-bada-7defffafced5?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
			'https://fileserver-g-p.sourcerer.tech/files/ebda502b-ab92-450f-a770-83a647d2c793?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
		],
		variant_ids: ['c2abb343-eee9-4e1b-94cb-dd5793e3bc68', '85d5b3e5-4559-470a-b5b1-9e7246f5ab9b', 'aeb76b2e-ea47-475e-a1fa-e23bf4a5b176'],
		type: 'similar_to_previous_order',
	},
};
export const trending_this_quarter = {
	status: 200,
	data: {
		image_urls: [
			'https://fileserver-g-p.sourcerer.tech/files/9b55bef1-7c77-4e64-bada-7defffafced5?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
			'https://fileserver-g-p.sourcerer.tech/files/ebda502b-ab92-450f-a770-83a647d2c793?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
		],
		variant_ids: ['b98b0c17-8567-492f-91e1-dbf1f1829acb'],
		type: 'trending_this_quarter',
	},
};
export const most_ordered_this_year = {
	status: 200,
	data: {
		image_urls: [
			'https://fileserver-g-p.sourcerer.tech/files/9b55bef1-7c77-4e64-bada-7defffafced5?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
			'https://fileserver-g-p.sourcerer.tech/files/ebda502b-ab92-450f-a770-83a647d2c793?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
		],
		variant_ids: [
			'80dfc073-c827-4b03-89c1-5cb58daa5052',
			'5adcfbc9-e196-4a21-bee8-e9c3096c63b4',
			'0e46cc87-83bb-40b3-add7-bde247cd7557',
			'b98b0c17-8567-492f-91e1-dbf1f1829acb',
			'85d5b3e5-4559-470a-b5b1-9e7246f5ab9b',
			'aeb76b2e-ea47-475e-a1fa-e23bf4a5b176',
		],
		type: 'most_ordered_this_year',
	},
};
export const all_time_best_sellers = {
	status: 200,
	data: {
		image_urls: [
			'https://fileserver-g-p.sourcerer.tech/files/9b55bef1-7c77-4e64-bada-7defffafced5?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
			'https://fileserver-g-p.sourcerer.tech/files/ebda502b-ab92-450f-a770-83a647d2c793?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
		],
		variant_ids: [
			'c2abb343-eee9-4e1b-94cb-dd5793e3bc68',

			'0e46cc87-83bb-40b3-add7-bde247cd7557',
			'b98b0c17-8567-492f-91e1-dbf1f1829acb',
			'85d5b3e5-4559-470a-b5b1-9e7246f5ab9b',
			'aeb76b2e-ea47-475e-a1fa-e23bf4a5b176',
		],
		type: 'all_time_best_sellers',
	},
};
export const often_paired_with_past_orders = {
	status: 200,
	data: {
		image_urls: [
			'https://fileserver-g-p.sourcerer.tech/files/9b55bef1-7c77-4e64-bada-7defffafced5?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
			'https://fileserver-g-p.sourcerer.tech/files/ebda502b-ab92-450f-a770-83a647d2c793?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
		],
		variant_ids: ['85d5b3e5-4559-470a-b5b1-9e7246f5ab9b'],
		type: 'often_paired_with_past_orders',
	},
};
export const last_order_date = {
	status: 200,
	data: {
		image_urls: [
			'https://fileserver-g-p.sourcerer.tech/files/9b55bef1-7c77-4e64-bada-7defffafced5?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
			'https://fileserver-g-p.sourcerer.tech/files/ebda502b-ab92-450f-a770-83a647d2c793?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
		],
		variant_ids: ['0e46cc87-83bb-40b3-add7-bde247cd7557', 'b98b0c17-8567-492f-91e1-dbf1f1829acb'],
		type: 'last_order_date',
	},
};
export const ordered_this_year = {
	status: 200,
	data: {
		image_urls: [
			'https://fileserver-g-p.sourcerer.tech/files/9b55bef1-7c77-4e64-bada-7defffafced5?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
			'https://fileserver-g-p.sourcerer.tech/files/ebda502b-ab92-450f-a770-83a647d2c793?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
		],
		variant_ids: ['b98b0c17-8567-492f-91e1-dbf1f1829acb', '85d5b3e5-4559-470a-b5b1-9e7246f5ab9b', 'aeb76b2e-ea47-475e-a1fa-e23bf4a5b176'],
		type: 'ordered_this_year',
	},
};
export const all_time_purchases = {
	status: 200,
	data: {
		image_urls: [
			'https://fileserver-g-p.sourcerer.tech/files/9b55bef1-7c77-4e64-bada-7defffafced5?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
			'https://fileserver-g-p.sourcerer.tech/files/ebda502b-ab92-450f-a770-83a647d2c793?transforms=[[%22resize%22,{%22width%22:280,%22height%22:250,%22fit%22:%22contain%22,%22background%22:%22white%22}]]',
		],
		variant_ids: [
			'80dfc073-c827-4b03-89c1-5cb58daa5052',
			'5adcfbc9-e196-4a21-bee8-e9c3096c63b4',
			'0e46cc87-83bb-40b3-add7-bde247cd7557',
			'b98b0c17-8567-492f-91e1-dbf1f1829acb',
			'85d5b3e5-4559-470a-b5b1-9e7246f5ab9b',
			'aeb76b2e-ea47-475e-a1fa-e23bf4a5b176',
		],
		type: 'all_time_purchases',
	},
};
